module.exports = __webpack_public_path__ + "img/battletrip_section2_mo.1738b6ad.jpg";